'use client';

import { isPopNavigation } from 'react-router-dom';
import { NavStateProvider } from 'commons/navState';

const NavStateBridgeProvider = ({ children }) => (
  <NavStateProvider value={isPopNavigation}>{children}</NavStateProvider>
);

export default NavStateBridgeProvider;
